import { render, staticRenderFns } from "./MiniLoader.vue?vue&type=template&id=227733c5&"
import script from "./MiniLoader.vue?vue&type=script&lang=js&"
export * from "./MiniLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports